"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    reactMuiTables: {
      selected: 'vybráno',
      filterhide: 'Schovat filter',
      filtershow: 'Zobrazit filter',
      refresh: 'Obnovit',
      filter: {
        actions: {
          search: 'Vyhledat',
          resetFilter: 'Resetovat filter',
          addCondition: 'Přidat podmínku'
        }
      },
      standardOperators: {
        equals: 'rovno',
        contains: 'obsahuje',
        between: {
          label: 'mezi',
          from: 'od',
          to: 'do'
        },
        oneOf: 'jeden z'
      },
      labelRowsPerPage: 'Řádků na stránku:'
    }
  }
};
var _default = messages;
exports.default = _default;